export const CLIENT_LOGIN = 'CLIENT_LOGIN'
export const CLIENT_PROFILE_SETTINGS = 'CLIENT_PROFILE_SETTINGS'
export const DOCUMENTS_PAGE = 'DOCUMENTS_PAGE'
export const CLIENT_DOCUMENTS = 'CLIENT_DOCUMENTS'
export const CLIENT_OVERVIEW = 'CLIENT_OVERVIEW'

export default {
  CLIENT_LOGIN,
  CLIENT_OVERVIEW,
  CLIENT_PROFILE_SETTINGS,
  DOCUMENTS_PAGE,
  CLIENT_DOCUMENTS,
}



// WEBPACK FOOTER //
// ./src/actionTypes/client/routing.js